//#region src/contacts/contact-slug-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Email = "email", e.FirstName = "first_name", e.Surname = "surname", e.Country = "country", e.City = "city", e.Neighborhood = "neighborhood", e.StreetAddress = "street_address", e.StreetNumber = "street_number", e.Postcode = "postcode", e.PhoneNumber = "phone_number", e.CompanyName = "company_name", e.TaxNumber = "tax_number", e.State = "state", e;
}({});
//#endregion
export { e as ContactSlugEnum };
